import React from 'react';

import { FallbackMessage } from './MissingTimeSlotsFallback.styled';
import { formatPhoneNumber } from 'kb-shared/utilities/phones';
import {
  MEMBER_SERVICES_PHONE_NUMBER,
  memberServicesPhoneHref
} from 'screens/Book/memberServicesPhone';

import { ContactPatientNavigatorLink } from '../ContactPatientNavigatorLink';

// Without an explicit phone, keep the original unformatted member services number.
export const MissingTimeSlotsFallback = ({ phone }: { phone?: string }) => (
  <FallbackMessage>
    <h2>There are no available time slots for this appointment.</h2>
    <p>Please reach out for scheduling options.</p>
    <p>
      <ContactPatientNavigatorLink /> or call{' '}
      <a href={memberServicesPhoneHref(phone ?? MEMBER_SERVICES_PHONE_NUMBER)}>
        {phone ? formatPhoneNumber(phone) : MEMBER_SERVICES_PHONE_NUMBER}
      </a>
    </p>
  </FallbackMessage>
);

export const DEFAULT_FALLBACK = <MissingTimeSlotsFallback />;
